export default "__VITE_ASSET__Ldj6zFO0__"